export default "__VITE_ASSET__Bzm9ijPF__"